<template>
  <v-container>
    <v-app-bar dark app color="primary">
      <v-app-bar-nav-icon>
        <v-icon>mdi-bed</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>Meldung häufiger Absenzen</v-toolbar-title>
      <v-spacer />
      <SearchField
        label="Name, Klasse oder Kürzel"
        v-model="search"
      ></SearchField>
      <template v-slot:extension>
        <DivisionTabs
          align-with-title
          all
          v-model="division"
          style="width: auto; margin-right: 2rem"
        />
        <TermTabs align-with-title v-model="term" />
      </template>
    </v-app-bar>
    <v-card :loading="loading">
      <FrequentAbsencesList
        :items="itemsFiltered"
        clickable
        @row-click="showFrequentAbsenceDetails"
      />
    </v-card>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import { searchPerson } from "common/utils/people";
import DateValue from "common/components/DateValue.vue";
import DivisionTabs from "@/components/DivisionTabs.vue";
import PersonItemBasic from "common/components/PersonItemBasic.vue";
import FrequentAbsencesList from "common/components/Absences/FrequentAbsencesList.vue";
import SearchField from "@/components/SearchField.vue";
import TermTabs from "@/components/TermTabs.vue";

export default defineComponent({
  name: "FrequentAbsences",
  components: {
    PersonItemBasic,
    DateValue,
    DivisionTabs,
    FrequentAbsencesList,
    SearchField,
    TermTabs,
  },
  data() {
    return { division: {}, items: [], term: {}, loading: false, search: "" };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "absence/frequentAbsences",
        query: `startDate=${this.term.startDate}&endDate=${this.term.endDate}`,
      });

      this.loading = false;
    },
    showFrequentAbsenceDetails(item) {
      this.$router.push({
        name: "PersonAbsences",
        params: { id: item.student.id },
      });
    },
  },
  computed: {
    itemsFiltered() {
      return this.items.filter(
        (el) =>
          (!el.student.schoolClass ||
            this.division.id === 0 ||
            this.division.id === el.student.schoolClass.division.id) &&
          (!this.search ||
            searchPerson(el.student, this.search) ||
            searchPerson(el.teacher, this.search))
      );
    },
  },
  watch: {
    term() {
      this.fetchData();
    },
  },
  created() {
    this.term = this.$_currentTerm;
    this.fetchData();
  },
});
</script>
